var React = require('react');

function ArrowInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M20.7207 9.64844L1.27925 9.64844","stroke":"#004C97","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M11 18.2971L1.27928 9.64858L11 1.00004","stroke":"#004C97","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

ArrowInline.defaultProps = {"width":"22","height":"20","viewBox":"0 0 22 20","fill":"none"};

module.exports = ArrowInline;

ArrowInline.default = ArrowInline;
